var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSendEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.28,37.21c.17,.17,.28,.36,.37,.56V9.53c-.1,.35-.27,.69-.57,.95l-14.2,12.33,14.4,14.4Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86,7.47L23.66,23.79,42.47,7.47c.23-.2,.5-.33,.78-.4H4.07c.28,.08,.55,.2,.78,.4Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.46,40.04l-14.6-14.6-2.88,2.5c-.37,.33-.84,.49-1.31,.49s-.94-.16-1.31-.49l-2.84-2.46-14.56,14.56c-.28,.28-.62,.42-.97,.5H43.43c-.35-.08-.7-.22-.97-.5Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.13,37.21l14.36-14.36L2.23,10.49c-.3-.26-.47-.6-.57-.95v28.49c.09-.3,.23-.58,.47-.81Z",
    fill: filledColor
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.67,7.04H3.67c-1.11,0-2,.89-2,2v29.48c0,1.11,.89,2,2,2H43.67c1.11,0,2-.89,2-2V9.04c0-1.11-.89-2-2-2ZM23.67,23.75L9.03,11.04h29.29l-14.65,12.71Zm-7.15-.91l-10.85,10.85V13.43l10.85,9.42Zm3.03,2.63l2.81,2.44c.38,.33,.84,.49,1.31,.49s.94-.16,1.31-.49l2.86-2.48,11.09,11.09H8.5l11.05-11.05Zm11.32-2.67l10.8-9.37v20.17l-10.8-10.8Z",
    fill: outlineColor
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.33,
    y: -0.22,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSendEmail);
export default __webpack_public_path__ + "static/media/ico-send-email.0d3a2854df300fd18b5ca2ca091f3e06.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;